import apiClient from "../apiClient";

let ControllerName = 'bundles';
const BundleController = Object.freeze({
    allBundles: `${ControllerName}`,
});

/*
 * Fetch all bundles from the server.
 *
 * @returns {Promise<Object[]>} A promise that resolves to the array of bundles if the request is successful.
 */
export const ShowBundles = async () => {
    try {
        const response = await apiClient.get(`${BundleController.allBundles}`);
        return response.data; 
    } catch (error) {
        console.log(error); 
    }
};

/*
 * Fetch the details of a single bundle based on its slug.
 * This function makes an API call to retrieve detailed information about a specific bundle.
 *
 * @param {string} BundleSlug - The unique identifier (slug) of the bundle to be fetched.
 * @returns {Promise<Object>} A promise that resolves to the details of the bundle if the request is successful.
 * 
 */
export const getBundleContent = async (BundleSlug) => {
    try {
        const response = await apiClient.get(`${BundleController.allBundles}/${BundleSlug}`);
        return response.data; 
    } catch (error) {
        console.log(error); 
    }
};
